import { Modality, Valence } from '../../../api/client'
import { ClassifierStatusFilter } from './ClassifierLibraryFilters'

export type ClassifierLibrarySearchState = {
    search: string
    modality?: Modality
    valence?: Valence
    status: ClassifierStatusFilter
    teamId?: number
    accountIds: number[]
    offset: number
    limit: number
}

export const DEFAULT_LIMIT = 100

export const DEFAULT_SEARCH_STATE: ClassifierLibrarySearchState = {
    search: '',
    status: 'active',
    accountIds: [],
    offset: 0,
    limit: DEFAULT_LIMIT
}

const STORAGE_KEY = 'classifierLibrarySearchState'

// sessionStorage rather than the URL: the sidebar link is a bare /admin/classifiers, so URL
// params would be lost exactly when an admin comes back to the list. — Claude
export function loadSearchState(): ClassifierLibrarySearchState {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY)
        if (!raw) return DEFAULT_SEARCH_STATE
        const saved = JSON.parse(raw) as Partial<ClassifierLibrarySearchState>
        return {
            ...DEFAULT_SEARCH_STATE,
            ...saved,
            // A stale or hand-edited value must not put the page on a zero page size.
            // A search saved before the picker took several profiles has no list.
            accountIds: Array.isArray(saved.accountIds) ? saved.accountIds : [],
            limit: saved.limit && saved.limit > 0 ? saved.limit : DEFAULT_LIMIT,
            offset: saved.offset && saved.offset > 0 ? saved.offset : 0
        }
    } catch {
        return DEFAULT_SEARCH_STATE
    }
}

export function saveSearchState(state: ClassifierLibrarySearchState) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch {
        // Storage can be blocked or full; losing the saved search is harmless. — Claude
    }
}
